import { LocationVarKey } from "@swivl-mono/types";
import LocationVarsModel from "../Variables/LocationVars.Model";

export class Subscription {
    static featureEnabled(feature: LocationVarKey) {
        let variables = LocationVarsModel.state.orgVariables;
        

        if (variables[feature] ) {
            return variables[feature]!.value === "1" || variables[feature]!.value === "true" ? true : false;
        }
        return false
    }
    static advancedAppsEnabled() {
        return Subscription.featureEnabled(LocationVarKey.SubscriptionPremiumApps);
    }
    
}